import { Component, model, input } from '@angular/core';
import { SubscriptionTermsConditionsModalComponent } from '../subscription-terms-conditions-modal/subscription-terms-conditions-modal.component';

@Component({
  selector: 'sura-pending-invoices-subscription',
  standalone: true,
  imports: [SubscriptionTermsConditionsModalComponent],
  templateUrl: './pending-invoices-subscription.component.html',
  styleUrl: './pending-invoices-subscription.component.scss'
})
export class PendingInvoicesSubscriptionComponent {
  isSubscriptionActive = model<boolean>(false);
  isDisabled = input<boolean>(false);
  isTermsModalVisible = false;

  toggleSubscription(): void {
    if (this.isDisabled()) return;
    this.isSubscriptionActive.update(v => !v);
  }

  openTermsModal(): void {
    this.isTermsModalVisible = true;
  }

  closeTermsModal(): void {
    this.isTermsModalVisible = false;
  }
}
